<template>
	<section class="container_main-top container_main-background-video">
		<video poster="@/assets/img/video-poster/short_loop-poster.jpg" autoplay muted loop playsinline class="fullscreen-bg__video">
			<source :src="source" type="video/mp4" />
		</video>
		<div class="header__overlay header__overlay_minor">
			<section class="header__overlay-item header__overlay-item-left">
				<div class="header__overlay-item-address">
					<div class="address">
						<a class="address__link" :href="address.href" target="blank">
							<div class="address__line">
								<span class="address__street">{{ address.street }}</span
								><span class="address__divider">,</span>
							</div>
							<div class="address_line">
								<span class="address__zip">{{ address.zip }}</span
								><span class="address__divider"> - </span><span class="address__city-extended">{{ address.city }}</span>
							</div>
						</a>
					</div>
				</div>
				<div v-if="openingHours !== 'closed'" class="header__overlay-item-hours">
					<p>Dnes otevřeno:</p>
					<p>{{ openingHours }}</p>
				</div>
				<div v-else class="header__overlay-item-hours">
					<p>Dnes zavřeno</p>
				</div>
			</section>
			<section class="header__overlay-item header__overlay-item-right">
				<div class="header__overlay-item-contact">
					<div class="contact__phone">
						<a class="contact__phone-link" :href="phoneHref">{{ phone }}</a>
					</div>
				</div>
				<div class="header__overlay-item-social__links">
					<ul class="social-links-inline">
						<li class="social-links-item social-links-facebook"><a :href="$cfg('social.fb')" target="blank" alt="facebook"></a></li>
						<li class="social-links-item social-links-instagram"><a :href="$cfg('social.ig')" target="blank" alt="instagram"></a></li>
					</ul>
				</div>
			</section>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			address: 'app/address',
			phone: 'app/phone',
			phoneHref: 'app/phoneHref',
			openingHours: 'app/openingHours',
		}),
	},

	data() {
		return {
			windowWidth: window.innerWidth,
			source: require('@/assets/video/short_loop-720p.mp4'),
		}
	},

	mounted() {
		if (this.windowWidth < 400) {
			this.source = require('@/assets/video/short_loop-480p.mp4')
		} else if (this.windowWidth < 767) {
			this.source = require('@/assets/video/short_loop-480p.mp4')
		} else if (this.windowWidth < 1440) {
			this.source = require('@/assets/video/short_loop-720p.mp4')
		} else {
			this.source = require('@/assets/video/short_loop-1080p.mp4')
		}
	},
}
</script>
